export default __webpack_public_path__ + "static/media/093-turn-right-1.0a7df25e.png";